export default __webpack_public_path__ + "static/media/apple.734de1e2.svg";